<template>
  <div class="single-column">
    <section class="single-column__section">
      <h2 class="single-column__heading">パスワード再設定</h2>
      <div class="login-block">
        <form
          @submit.prevent="submitForm">
          <div class="form-wrap">
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="InputEmail">メールアドレス
                </label>
              </div>
              <div class="form-item">
                <input
                  id="InputEmail"
                  v-model="input"
                  class="form-control"
                  type="email"
                  name="PhoneNumber"
                  value=""
                  placeholder="例）sample@example.com">
                <p class="error-text">メールアドレスが入力されていません</p>
              </div>
            </div>
          </div>
          <div class="form-btn-area">
            <button
              class="c-btn"
              :class="{ 'c-btn--off' : !input }"
              type="submit"
              name="submit"
              :disabled="!input"
              @click.prevent="submitForm">
              送信する<span class="c-btn__icon-arrow"></span>
            </button>
          </div>
          <div class="form-foot-linkarea">
            <router-link
              :to="{ name: 'sign-up' }"
              class="c-text-link">
              アカウント登録（無料）
            </router-link>
            <router-link
              :to="{ name: 'login' }"
              class="c-text-link">
              ログイン
            </router-link>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Password',
  data() {
    return {
      input: '',
    }
  },
}
</script>

<style scoped>

</style>
